// @ts-nocheck
import React, { Component } from "react";
import * as Sentry from "@sentry/react";

class ErrorBoundary extends Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false, error: null };
	}

	static getDerivedStateFromError(error) {
		return { hasError: true, error };
	}

	componentDidCatch(error, errorInfo) {
		Sentry.withScope((scope) => {
			scope.setExtras(errorInfo);
			Sentry.captureException(error);
		});
	}

	handleReset = () => {
		this.setState({ hasError: false, error: null });
	};

	render() {
		if (this.state.hasError) {
			if (this.props.fallback) {
				return this.props.fallback({
					error: this.state.error,
					resetError: this.handleReset,
				});
			}
			return (
				<div
					style={{
						display: "flex",
						flexDirection: "column",
						alignItems: "center",
						justifyContent: "center",
						height: "100vh",
						padding: "2rem",
						textAlign: "center",
					}}
				>
					<h2>Une erreur est survenue</h2>
					<p style={{ color: "#666", marginTop: "1rem" }}>
						L&apos;application a rencontré un problème
						inattendu.
					</p>
					<button
						onClick={() => window.location.reload()}
						style={{
							marginTop: "1.5rem",
							padding: "0.75rem 1.5rem",
							border: "none",
							borderRadius: "4px",
							backgroundColor: "#1976d2",
							color: "#fff",
							cursor: "pointer",
							fontSize: "1rem",
						}}
					>
						Recharger la page
					</button>
				</div>
			);
		}
		return this.props.children;
	}
}

export default ErrorBoundary;
